export { default } from './AnalyticalReport';